import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { C4gPaginatorComponent } from './paginator.component';
import { PageDropdownComponent } from './page-dropdown.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [C4gPaginatorComponent, PageDropdownComponent],
  imports: [CommonModule, FormsModule],
  exports: [C4gPaginatorComponent, PageDropdownComponent],
  providers: [
    {
      provide: MatPaginatorIntl,
      useValue: new MatPaginatorIntl()
    }
  ]
})
export class C4gPaginatorModule { }
